import React, {useMemo} from 'react';
import Skeleton from 'react-loading-skeleton'
import {getAccessToken} from '../../../../api';
const IframeResizer = React.lazy(()=>import('./LazyIframeResizer'))

export default function IFrameComponent({src}){
  const url = useMemo(()=>{
    if(src){
      try{
        const u = new URL(src)
        u.searchParams.append('access_token', getAccessToken())
        return u.href;
      }catch(e){

      }
    }
  },[src])
  return <React.Suspense fallback={<Skeleton height={200} />}>
    <IframeResizer src={url}/>
  </React.Suspense>
}
